import { Box, TextField, Button, FormControl, InputLabel } from "@mui/material";
import styled from "styled-components";

const ButtonSection = styled.div`
  display: flex;
  height : "30px";
  align-items: center;
  // flex-wrap: wrap;
  // margin-top: 50px;
  gap: 10px;
  // margin-left: 90px;
  justify-content : flex-end;
    // text-align: right;
`;

const MyButtonGroup = ({ children }) => {
  return (
    <ButtonSection > {children} </ButtonSection>
  );
};

export default MyButtonGroup;
